import { cn } from '@/lib/utils'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs'

interface ITab {
    value: string
    label: React.ReactNode
    content: React.ReactNode
    disabled?: boolean
}

interface IProps {
    tabs: ITab[]
    className?: string
    defaultValue?: string
    onChange?: (value: string) => void
}

export function SimpleTabs(props: IProps) {
    const isSingleTab = props.tabs.length === 1

    return (
        <div className={cn('flex flex-col gap-6 max-w-full', props.className)}>
            <Tabs
                defaultValue={props.defaultValue || props.tabs.at(0)?.value}
                onValueChange={props.onChange}
            >
                <TabsList>
                    {isSingleTab ? (
                        <TabsTrigger
                            key={props.tabs[0].value}
                            value={props.tabs[0].value}
                            disabled
                        >
                            {props.tabs[0].label}
                        </TabsTrigger>
                    ) : (
                        props.tabs.map(tab => (
                            <div
                                key={tab.value}
                                className={cn('flex-1 flex', {
                                    'cursor-not-allowed': tab.disabled,
                                })}
                            >
                                <TabsTrigger
                                    value={tab.value}
                                    disabled={tab.disabled}
                                >
                                    {tab.label}
                                </TabsTrigger>
                            </div>
                        ))
                    )}
                </TabsList>
                {props.tabs.map(tab => (
                    <TabsContent key={tab.value} value={tab.value}>
                        {tab.content}
                    </TabsContent>
                ))}
            </Tabs>
        </div>
    )
}
